export const FLAG_PERMISSIONS = {
  "cashieredDevices": [
    "Cashier",
    "Cashier Modes"
   ],
};